angular.
module("dx.webapp.api").
factory("dxApiV1ExternalTools", function apiV1ExternalTools(
	$http,
	$httpParamSerializer
) {
	"use strict";

	var baseUrl = "/api/v1/externaltools";

	function toolsGetByID(toolId) {
		return $http.get(baseUrl + "/" + toolId).then(function success(response) {
			return response;
		});
	}

	function toolsGetAll(orgId) {
		if (orgId) {
			return $http.get(baseUrl + "?" + $httpParamSerializer({orgId: orgId}));
		}
		return $http.get(baseUrl);
	}

	function toolsPost(externalTool) {
		return $http.post(baseUrl, externalTool).then(function success(response) {
			return response;
		});
	}

	function toolsPut(toolId, externalTool) {
		return $http.put(baseUrl + "/" + toolId, externalTool).then(function success(response) {
			return response;
		});
	}

	function toolsDelete(toolId) {
		return $http.delete(baseUrl + "/" + toolId).then(function success(response) {
			return response;
		});
	}

	function toolsGetUsedInTemplateCount(toolId) {
		return $http.get(baseUrl + "/" + toolId + "/examtemplates").then(function success(response) {
			return response.data.count;
		});
	}

	return {
		get: toolsGetByID,
		list: toolsGetAll,
		post: toolsPost,
		put: toolsPut,
		delete: toolsDelete,
		getUsedInExamTemplateCount: toolsGetUsedInTemplateCount,
	};
});
